// @generated by protoc-gen-connect-es v1.6.1
// @generated from file omnios/v1/ai.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { AddAgentStepRequest, AddAgentStepResponse, AgentProfile, AgentRun, AgentSession, AgentStep, ApproveAgentStepRequest, Classification, ClassifyMessageRequest, CodeTemplate, CreateAgentProfileRequest, CreateAgentSessionRequest, CreateAgentSessionResponse, CreateCodeTemplateRequest, DeleteAgentProfileRequest, DeleteAgentProfileResponse, DeleteAgentSessionRequest, DeleteAgentSessionResponse, DeleteCodeTemplateRequest, DeleteCodeTemplateResponse, DeleteKnowledgeDocumentRequest, DeleteKnowledgeDocumentResponse, ExtractOrderRequest, ExtractOrderResponse, GcAgentSessionsRequest, GcAgentSessionsResponse, GenerateProductSeoRequest, GenerateProductSeoResponse, GetAgentProfileRequest, GetAgentRunRequest, GetAgentSessionRequest, GetKnowledgeChunksRequest, GetKnowledgeChunksResponse, InvokeAgentRequest, KnowledgeDocument, ListAgentProfilesRequest, ListAgentProfilesResponse, ListAgentRunsRequest, ListAgentRunsResponse, ListAgentSessionFilesRequest, ListAgentSessionFilesResponse, ListAgentSessionsRequest, ListAgentSessionsResponse, ListCodeTemplatesRequest, ListCodeTemplatesResponse, ListKnowledgeDocumentsRequest, ListKnowledgeDocumentsResponse, MatchProductsRequest, MatchProductsResponse, ReplyChunk, RequestAgentApprovalRequest, RequestAgentApprovalResponse, ResolveAgentFilePathRequest, ResolveAgentFilePathResponse, SendAgentMessageRequest, StreamAgentRunRequest, SuggestReplyRequest, TranslateProductRequest, TranslateProductResponse, UpdateAgentProfileRequest, UploadKnowledgeDocumentRequest } from "./ai_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service omnios.v1.AIService
 */
export const AIService = {
  typeName: "omnios.v1.AIService",
  methods: {
    /**
     * High-level AI operations
     *
     * @generated from rpc omnios.v1.AIService.ClassifyMessage
     */
    classifyMessage: {
      name: "ClassifyMessage",
      I: ClassifyMessageRequest,
      O: Classification,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AIService.SuggestReply
     */
    suggestReply: {
      name: "SuggestReply",
      I: SuggestReplyRequest,
      O: ReplyChunk,
      kind: MethodKind.ServerStreaming,
    },
    /**
     * @generated from rpc omnios.v1.AIService.ExtractOrder
     */
    extractOrder: {
      name: "ExtractOrder",
      I: ExtractOrderRequest,
      O: ExtractOrderResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AIService.MatchProducts
     */
    matchProducts: {
      name: "MatchProducts",
      I: MatchProductsRequest,
      O: MatchProductsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Agent lifecycle -- agents are parties, so CRUD is via PartyService
     * These RPCs handle agent *execution*
     *
     * @generated from rpc omnios.v1.AIService.InvokeAgent
     */
    invokeAgent: {
      name: "InvokeAgent",
      I: InvokeAgentRequest,
      O: AgentStep,
      kind: MethodKind.ServerStreaming,
    },
    /**
     * @generated from rpc omnios.v1.AIService.SendAgentMessage
     */
    sendAgentMessage: {
      name: "SendAgentMessage",
      I: SendAgentMessageRequest,
      O: AgentStep,
      kind: MethodKind.ServerStreaming,
    },
    /**
     * @generated from rpc omnios.v1.AIService.ApproveAgentStep
     */
    approveAgentStep: {
      name: "ApproveAgentStep",
      I: ApproveAgentStepRequest,
      O: AgentRun,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AIService.GetAgentRun
     */
    getAgentRun: {
      name: "GetAgentRun",
      I: GetAgentRunRequest,
      O: AgentRun,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AIService.ListAgentRuns
     */
    listAgentRuns: {
      name: "ListAgentRuns",
      I: ListAgentRunsRequest,
      O: ListAgentRunsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AIService.StreamAgentRun
     */
    streamAgentRun: {
      name: "StreamAgentRun",
      I: StreamAgentRunRequest,
      O: AgentStep,
      kind: MethodKind.ServerStreaming,
    },
    /**
     * Knowledge Base
     *
     * @generated from rpc omnios.v1.AIService.UploadKnowledgeDocument
     */
    uploadKnowledgeDocument: {
      name: "UploadKnowledgeDocument",
      I: UploadKnowledgeDocumentRequest,
      O: KnowledgeDocument,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AIService.ListKnowledgeDocuments
     */
    listKnowledgeDocuments: {
      name: "ListKnowledgeDocuments",
      I: ListKnowledgeDocumentsRequest,
      O: ListKnowledgeDocumentsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AIService.DeleteKnowledgeDocument
     */
    deleteKnowledgeDocument: {
      name: "DeleteKnowledgeDocument",
      I: DeleteKnowledgeDocumentRequest,
      O: DeleteKnowledgeDocumentResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AIService.GetKnowledgeChunks
     */
    getKnowledgeChunks: {
      name: "GetKnowledgeChunks",
      I: GetKnowledgeChunksRequest,
      O: GetKnowledgeChunksResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Agent Sessions (filesystem)
     *
     * @generated from rpc omnios.v1.AIService.ListAgentSessions
     */
    listAgentSessions: {
      name: "ListAgentSessions",
      I: ListAgentSessionsRequest,
      O: ListAgentSessionsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AIService.CreateAgentSession
     */
    createAgentSession: {
      name: "CreateAgentSession",
      I: CreateAgentSessionRequest,
      O: CreateAgentSessionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AIService.GetAgentSession
     */
    getAgentSession: {
      name: "GetAgentSession",
      I: GetAgentSessionRequest,
      O: AgentSession,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AIService.DeleteAgentSession
     */
    deleteAgentSession: {
      name: "DeleteAgentSession",
      I: DeleteAgentSessionRequest,
      O: DeleteAgentSessionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AIService.GcAgentSessions
     */
    gcAgentSessions: {
      name: "GcAgentSessions",
      I: GcAgentSessionsRequest,
      O: GcAgentSessionsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AIService.ListAgentSessionFiles
     */
    listAgentSessionFiles: {
      name: "ListAgentSessionFiles",
      I: ListAgentSessionFilesRequest,
      O: ListAgentSessionFilesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Agent file resolution
     *
     * @generated from rpc omnios.v1.AIService.ResolveAgentFilePath
     */
    resolveAgentFilePath: {
      name: "ResolveAgentFilePath",
      I: ResolveAgentFilePathRequest,
      O: ResolveAgentFilePathResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Agent self-management (called from CLI inside sandbox)
     *
     * @generated from rpc omnios.v1.AIService.RequestAgentApproval
     */
    requestAgentApproval: {
      name: "RequestAgentApproval",
      I: RequestAgentApprovalRequest,
      O: RequestAgentApprovalResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AIService.AddAgentStepFromCli
     */
    addAgentStepFromCli: {
      name: "AddAgentStepFromCli",
      I: AddAgentStepRequest,
      O: AddAgentStepResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Agent Profiles
     *
     * @generated from rpc omnios.v1.AIService.CreateAgentProfile
     */
    createAgentProfile: {
      name: "CreateAgentProfile",
      I: CreateAgentProfileRequest,
      O: AgentProfile,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AIService.UpdateAgentProfile
     */
    updateAgentProfile: {
      name: "UpdateAgentProfile",
      I: UpdateAgentProfileRequest,
      O: AgentProfile,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AIService.DeleteAgentProfile
     */
    deleteAgentProfile: {
      name: "DeleteAgentProfile",
      I: DeleteAgentProfileRequest,
      O: DeleteAgentProfileResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AIService.ListAgentProfiles
     */
    listAgentProfiles: {
      name: "ListAgentProfiles",
      I: ListAgentProfilesRequest,
      O: ListAgentProfilesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AIService.GetAgentProfile
     */
    getAgentProfile: {
      name: "GetAgentProfile",
      I: GetAgentProfileRequest,
      O: AgentProfile,
      kind: MethodKind.Unary,
    },
    /**
     * Code Templates
     *
     * @generated from rpc omnios.v1.AIService.CreateCodeTemplate
     */
    createCodeTemplate: {
      name: "CreateCodeTemplate",
      I: CreateCodeTemplateRequest,
      O: CodeTemplate,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AIService.DeleteCodeTemplate
     */
    deleteCodeTemplate: {
      name: "DeleteCodeTemplate",
      I: DeleteCodeTemplateRequest,
      O: DeleteCodeTemplateResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AIService.ListCodeTemplates
     */
    listCodeTemplates: {
      name: "ListCodeTemplates",
      I: ListCodeTemplatesRequest,
      O: ListCodeTemplatesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Product content generation
     *
     * @generated from rpc omnios.v1.AIService.GenerateProductSeo
     */
    generateProductSeo: {
      name: "GenerateProductSeo",
      I: GenerateProductSeoRequest,
      O: GenerateProductSeoResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AIService.TranslateProduct
     */
    translateProduct: {
      name: "TranslateProduct",
      I: TranslateProductRequest,
      O: TranslateProductResponse,
      kind: MethodKind.Unary,
    },
  }
};

